import { render, staticRenderFns } from "./PaginationPainel.vue?vue&type=template&id=db9d8932&"
import script from "./PaginationPainel.vue?vue&type=script&lang=js&"
export * from "./PaginationPainel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports